import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import useStateRef from "react-usestateref";
import { useHistory } from 'react-router-dom';

export default function InternalFacetsContainer({ containerObject, templateName, contentId, dataZone }) {
	const [facetObj, setfacetObj] = useState(containerObject);

	return (
		<>
			<div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0`} >
				<div className="d-none d-lg-block">
					<h2 className="c-sidepanel-heading" >{facetObj.currentProductCategoryName ? facetObj.currentProductCategoryName : ""}</h2>
					<div className="c-side-list">
						<ul className="list-group">
							{facetObj && facetObj.facets.map((facet) => {
								return (<>
									{facet.Content_Category ? facet.Content_Category.map((item, index) => {
										return (<li className="list-group-item">
											{item.childCategory != null && item.childCategory.length > 0 ?
												<>
													<div className="accordion childFacets" id={`accordionExample${index}`}>
														<div className="accordion-item">
															<h2 className="accordion-header" id="headingOne">
																<button className="accordion-button list-group-item-action accordion-button-header collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${index}`} aria-expanded="true" aria-controls="collapseOne">
																	{item.name}
																</button>
															</h2>
														</div>
														<div id={`collapseOne${index}`} className="accordion-collapse collapse accordion-body-width" aria-labelledby="headingOne">
															{item.childCategory.map((oneCategory, index) => {
																return (<>
																	<Link className="accordion-body-padding row" to={oneCategory.childCategoryUrl}>{oneCategory.childCategoryName}</Link>
																</>)
															})}
														</div>
													</div>
												</>
												:
												<Link className="list-group-item-action" to={item.url}>{item.name}<span className="c-list-icon">
													<i className="fa fa-play fa-icon-style" aria-hidden="true">
													</i>
												</span>
												</Link>
											}

										</li>)
									})
										: <>
											{facet ? Object.entries(facet).map(([key, value], indexs) => {
												return (<li classNameName="list-group-item">
													<div className="accordion childFacets" id={`accordionExample${indexs}`}>
														<div className="accordion-item">
															<h2 className="accordion-header" id="headingOne">
																<button className={`accordion-button list-group-item-action accordion-button-header ${indexs < 3 ? "" : "collapsed"} `} type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${key.includes(" ") ? key.replace(/[" "]/g, "_")  : key ? key : ""}`} aria-expanded="true" aria-controls="collapseOne">
																	{key ? key : ""}
																</button>
															</h2>
														</div>
														<div id={`collapseOne${key.includes(" ") ? key.replace(/[" "]/g, "_")  : key ? key : ""}`} className={`accordion-collapse collapse accordion-body-width ${indexs < 3 ? "show" : ""}`} aria-labelledby="headingOne">
															<ul className="c-accordion-list">
																{value.map((oneCategory, index) => {
																	return (<>
																		<Link className="c-refine-check form-check row" to={oneCategory.url ? oneCategory.url : ""}>
																			<label className="form-check-label" htmlFor={`product_productTypes_displayName${index}`}>
																				<input id={`product_productTypes_displayName${index}`} className="form-check-input" type="checkbox" />
																				{oneCategory.name ? oneCategory.name : ""}
																				<span className="form-check-value"> &nbsp;{oneCategory.count ? "(" + oneCategory.count + ")" : ""}</span>
																			</label>
																		</Link>
																	</>)
																})}
															</ul>
														</div>
													</div>
												</li>
												)
											}) : ""}

										</>}
								</>)
							})
							}
						</ul>
					</div>
				</div>
			</div>
		</>
	);
}
